export default "__VITE_ASSET__c8bad8f3__"